import React, { useState } from 'react';
import { useStaticQuery, graphql } from 'gatsby';
import Img from 'gatsby-image';
import searchIcon from '../resource/search-icon.svg';
import closeIcon from '../resource/close-icon.svg';

export default () => {
  const data = useStaticQuery(graphql`
    query {
      allInventoryJson {
        edges {
          node {
            id
            name
            slug
            category
            brand
            images {
              id
              publicURL
              childImageSharp {
                fluid {
                  ...GatsbyImageSharpFluid
                }
              }
            }
          }
        }
      }
    }
  `);

  const [searchQuery, setSearchQuery] = useState('');
  const inventory = data.allInventoryJson.edges;
  const [filteredInventory, setFilteredInventory] = useState(inventory);

  function handleChange(e) {
    setSearchQuery(e.target.value);

    if (e.target.value.length === 0) {
      setFilteredInventory(inventory);
    } else {
      setFilteredInventory(
        inventory.filter((item) => {
          return (
            JSON.stringify([
              item.node.name,
              item.node.brand,
              item.node.category,
            ])
              .toLowerCase()
              .search(e.target.value.toLowerCase()) !== -1
          );
        })
      );
    }
  }

  return (
    <div
      css={`
        width: 100%;
        display: flex;
        padding: 0 1rem;
        align-items: center;
        gap: 0.4rem;
      `}
    >
      <img src={searchIcon} alt="" css="height: 1.4rem" />
      <input
        value={searchQuery}
        onChange={handleChange}
        placeholder="SEARCH"
        css={`
          padding: 0.5rem;
          border: none;
          width: 100%;
          height: 2rem;
          position: static;
        `}
      />
      <button
        onClick={() => setSearchQuery('')}
        css={`
          border: none;
          background-color: inherit;
          height: 2rem;
          display: flex;
          align-items: center;
        `}
      >
        {searchQuery && (
          <img
            src={closeIcon}
            alt=""
            css={`
              height: 1.4rem;
              :hover {
                cursor: pointer;
              }
            `}
          />
        )}
      </button>
      <div
        css={`
          position: absolute;
          top: 3rem;
          left: 0;
          width: 200%;

          transform: translate(
            -25%,
            ${!searchQuery || !filteredInventory.length ? -1 : 0}px
          );
          height: ${searchQuery
            ? Math.max(1, filteredInventory.length) * 3
            : 0}rem;
          transition: height 200ms;
          z-index: 1;
          overflow: hidden;
          background: white;
          border: 1px solid black;
          border-top: none;

          > * + * {
            border-top: 1px solid black;
          }

          @media only screen and (max-width: 768px) {
            width: 100%;
            border-left: none;
            border-right: none;
            transform: translate(0, 4px);
          }
        `}
      >
        {filteredInventory.map(({ node }) => (
          <div
            key={node.id}
            css={`
              padding: 0.4rem;
              height: 3rem;
              display: flex;
              align-items: center;
              gap: 0.5rem;
            `}
          >
            <Img
              fluid={node.images[0].childImageSharp.fluid}
              alt=""
              css="width: 3rem"
            />
            <a href={node.slug}>{node.name}</a>
          </div>
        ))}
        {!filteredInventory.length && (
          <div
            css={`
              padding: 0.4rem;
              height: 3rem;
              display: flex;
              align-items: center;
            `}
          >
            NO RESULTS
          </div>
        )}
      </div>
    </div>
  );
};
